import React from 'react';

interface QuotationNameStepProps {
  name: string;
  onChange: (name: string) => void;
}

export function QuotationNameStep({ name, onChange }: QuotationNameStepProps) {
  return (
    <div className="space-y-6">
      <div>
        <label htmlFor="name" className="block text-sm font-medium text-gray-700">
          Quotation Name
        </label>
        <input
          type="text"
          id="name"
          value={name}
          onChange={(e) => onChange(e.target.value)}
          className="mt-1 block w-full"
          placeholder="Enter a name for this quotation"
          required
        />
      </div>
    </div>
  );
}